import {defineMessages} from 'react-intl';

//@TODO [CHP-42] fix translations
export default defineMessages({
	login: {
		id: 'header.login',
		defaultMessage: 'Log in'
	},
	wishlist: {
		id: 'header.wishlist',
		defaultMessage: 'Wishlist',
	},
	findInStore: {
		id: 'header.findInStore',
		defaultMessage: 'Find in Store',
	},
	bookAppointment: {
		id: 'header.bookAnAppointment',
		defaultMessage: 'Book an appointment'
	},
	myAccount: {
		id: 'header.myAccount',
		defaultMessage: 'My Account',
	},
});
